import styled from 'styled-components'
import fonts from '../../tokens/fonts'
import colors from '../../tokens/colors'
import border from '../../tokens/border'
import typography from '../../tokens/typography'
import layout from '../../tokens/layout'
import ShadowToken from '../../tokens/shadow'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const CardContainer = styled.div.attrs((props) => composeTheme(props))`
  display: grid;
  min-width: 18rem;
  min-height: 7rem;
  border: ${border.width.widthHairline} solid ${colors.neutralColorHighDark};
  padding: ${layout.padding.spacingInsetSm};
  border-radius: 12px;
  box-shadow: ${ShadowToken.shadowLevel1};
  background-color: ${colors.neutralColorHighPure};

  &:focus {
    outline: ${(props) => props.theme.card.primaryFocusOutline};
    box-shadow: ${(props) => props.theme.card.primaryFocusShadow};
  }
`
export const Title = styled.div`
  font-size: ${typography.fontSize.fontSizeXs};
  font-weight: ${typography.fontWeight.fontWeightRegular};
  font-family: ${fonts.inter};
  line-height: ${typography.fontHeight.lineHeightLg};
  color: ${colors.neutralColorLowDark};
`
export const Description = styled.div`
  font-size: ${typography.fontSize.fontSizeMd};
  font-weight: ${typography.fontWeight.fontWeightBold};
  font-family: ${fonts.inter};
  line-height: ${typography.fontHeight.lineHeightLg};
  display: grid;
  grid-gap: 0.5rem;
  width: 100%;
  min-width: ${layout.margin.spacingXxl};
`
export const WrapperTitle = styled.div`
  display: flex;
  color: ${colors.neutralColorLowDark};
  margin-bottom: 5px;
  > *:first-child {
    margin-right: 5px;
  }
`
export const VisibilityContainer = styled.div`
  > div {
    cursor: pointer;
    position: static;
    color: ${colors.neutralColorLowDark};
    justify-content: space-between;
    width: 100%;
    margin-bottom: auto;
  }
`
export const WrapperValue = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.margin.spacingNano};
  svg {
    color: ${colors.neutralColorLowDark};
  }
`
export const VisibilityOffContainer = styled.div`
  max-width: 12rem;
  height: 3.4rem;
  grid-gap: 0.5rem;
  padding: ${layout.padding.spacingInsetNone} 30%;
  background-color: ${colors.neutralColorHighMedium};
`
export const Text = styled.div``

CardContainer.defaultProps = defaultTheme
